<script setup lang="ts">

</script>

<template>
    <v-card
        variant="outlined"
        class="bg-gradient"
        color="grey-lighten-2"
        rounded="lg"
    >
        <v-card-title class="text-body-2 font-weight-bold text-black">
            Welcome to your feed!
        </v-card-title>
        <v-card-text class="text-body-2 text-black">
            We're updating your feed with the latest transfer from your projects 🚀.
        </v-card-text>
    </v-card>
</template>

<style scoped>
.bg-gradient {
    background: linear-gradient(0deg, #FFF 0%, #E9E9F6 100%);
}
</style>
